import styled from 'styled-components';

export const PagePreviewContainer = styled.div`
    flex: 1;
    position: relative;

    .preview {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
    }
`;

export const PreviewToolbar = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 28px;
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    right: 0;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: none !important;
    }
`;
